import type { QueryParameterConfig } from '@pba/react-router';
import { type OnboardingTourStepOption, isOnboardingTourStepOption } from 'models';

// eslint-disable-next-line @typescript-eslint/naming-convention -- need to be renamed to not eslint error
export const StepParameter = {
  decode(value?: Array<null | string> | null | string) {
    if (isOnboardingTourStepOption(value)) {
      return value;
    }

    return undefined;
  },

  default: undefined,
  encode(value?: OnboardingTourStepOption) {
    return value;
  },
} satisfies QueryParameterConfig<OnboardingTourStepOption | undefined>;
